import { FARE_MIN_NGN, FARE_STEP_NGN } from './constants';

/** Fare shown before the trip: the road distance (km along the real road route, plus each pin's distance to its road) x per-km price, rounded to ₦50, minimum ₦500. */
export function fareForKm(roadKm: number, perKm: number): number {
  const raw = (roadKm * perKm) / FARE_STEP_NGN;
  return Math.max(FARE_MIN_NGN, Math.round(raw) * FARE_STEP_NGN);
}

export type PriceSource = 'app' | 'own' | 'rider';

export interface PricingProfile {
  mode: 'city' | 'local';
  pm: 'app' | 'own' | 'both'; // Local drivers pick App price or Driver price only
  cityKm: number;
  localKm: number;
  localAppKm: number | null; // the Local app price per km for this driver's vehicle kind, as the admin set it; null until the admin sets it
  cityAppKm: number | null; // the City app price per km for this driver's vehicle grade, as the admin set it; null until the admin sets it
}

/** Which price sources a driver can offer for a trip of the given range. A Local driver offers the app price or their own price, never both. The app price is offered only once the admin has set it. */
export function sourcesFor(p: PricingProfile, range: 'city' | 'local'): PriceSource[] {
  const all: PriceSource[] = range === 'local' ? [p.pm === 'app' ? 'app' : 'own'] : p.pm === 'both' ? ['app', 'own'] : [p.pm];
  return all.filter((s) => s !== 'app' || perKmFor(p, 'app', range) !== null);
}

/** The per-km price for a source; null for the app price while the admin has not set it. */
export function perKmFor(p: PricingProfile, src: PriceSource, range: 'city' | 'local'): number | null {
  if (range === 'local') return src === 'app' ? p.localAppKm : p.localKm;
  return src === 'app' ? p.cityAppKm : p.cityKm;
}
